import { FC, useEffect, useState } from 'react'
import MuiLinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress'

const LinearProgress: FC<LinearProgressProps & { delay?: number }> = ({ delay, ...props }) => {
  const [shouldRender, setShouldRender] = useState(!delay)
  useEffect(() => {
    const timeout = delay
      ? setTimeout(() => {
          setShouldRender(true)
        }, delay)
      : undefined
    return () => {
      clearTimeout(timeout)
    }
  }, [delay])
  if (!shouldRender) {
    return null
  }
  return <MuiLinearProgress {...props} />
}

export default LinearProgress
